import React from 'react';
import hasValidationErrors from 'components/connectedForm/utils/hasValidationErrors';
import { createBackgroundProcess } from 'utils/BackgroundJobs';
import BankTransferPostMutation from 'graphql/mutations/bank/BankTransferPostMutation.graphql';
import createPostingPreview from '../../views/nominal/NominalPostingPreviewForm';
import BankTransferPostingPreview from 'graphql/entities/bank/BankTransferPostingPreview';
import BankTransferTransactions from 'graphql/entities/bank/BankTransferTransactions';
import createPostedTransactions from '../../views/nominal/PostedTransactionsForm';
import { PostSelectButton } from '../../components/SelectButton';
import getClientMutationId from '../../utils/getClientMutationId';

const BANK_TRANSFER_POSTING_PREVIEW = createPostingPreview(BankTransferPostingPreview);
const BANK_TRANSFER_POSTED_TRANSACTIONS = createPostedTransactions(BankTransferTransactions);

export const formActions = [
  {
    description: 'Preview Postings',
    triggerModal: {
      modalContent: BANK_TRANSFER_POSTING_PREVIEW,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Postings/bank/Transfer',
        forceReadOnly: true,
      },
    },
    performSave: true,
    saveMessage: 'Nominal/VAT Postings Preview',
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPreview,
  },
  {
    description: 'View Transactions',
    triggerModal: {
      modalContent: BANK_TRANSFER_POSTED_TRANSACTIONS,
      entityId: 'id',
      pageView: true,
      modalProps: {
        formEntityCustomUrl: 'nominal/Transactions/bank/Transfer',
        forceReadOnly: true,
      },
    },
    btnClass: 'btnInfo',
    individualButton: true,
    condition: displayPosted,
  },
  {
    description: 'Post Transfer',
    component: PostSelectButton,
    fn: postTransaction,
    individualButton: true,
    performSave: true,
    saveMessage: 'Bank transfer posted',
    condition: canBePosted,
  },
];

function displayPreview(values) {
  if (values && values.documentStatus) {
    return values.documentStatus === 'DRAFT' || values.documentStatus === 'RELEASED';
  }
  return false;
}

function displayPosted(values) {
  if (values && values.documentStatus) {
    return values.documentStatus === 'POSTED';
  }
  return false;
}

function canBePosted(values) {
  if (values && values.documentStatus) {
    return values.documentStatus === 'DRAFT';
  }
  return false;
}

function postTransaction(props) {
  const { values, connectedForm } = props;
  if (hasValidationErrors(connectedForm)) return;
  const input = {
    clientMutationId: getClientMutationId(),
    id: values.id,
  };
  createBackgroundProcess(BankTransferPostMutation, input, props, 'back', 'Post Transfer');
}
